module.exports = __webpack_public_path__ + "fonts/manrope-thin.0967a714.otf";